/**
 * Módulo de programas de mantenimiento — CRUD, reactivación y consulta de órdenes vinculadas
 */

import { createCrudMethods } from '../base/crudMethods';

/**
 * Crea el módulo de programas de mantenimiento
 *
 * @param {Object} deps - Dependencias inyectadas
 * @param {Function} deps.authenticatedRequest - Función de request autenticada
 * @returns {Object} Métodos del módulo programas
 */
export function createProgramasModule({ authenticatedRequest }) {
  return {
    ...createCrudMethods(
      {
        endpoint: '/api/programas',
        entityName: 'programa',
        entityNamePlural: 'programas'
      },
      { authenticatedRequest }
    ),

    /**
     * Reactiva un programa pausado, generando mantención si no hay activa
     *
     * @param {number} programaId - ID del programa
     * @param {Object} data - Datos de reactivación
     * @param {string} [data.proxima_ejecucion] - Fecha para nueva mantención (requerida si no hay activa)
     * @returns {Promise<{success: boolean, message: string}>}
     */
    async reactivarPrograma(programaId, data) {
      return await authenticatedRequest(`/api/programas/${programaId}/reactivar`, {
        method: 'POST',
        body: JSON.stringify(data)
      });
    },

    /**
     * Obtiene mantenciones vinculadas a un programa
     *
     * @param {number} programaId - ID del programa
     * @returns {Promise<{success: boolean, data: Array}>}
     */
    async getOrdenTrabajoPrograma(programaId) {
      return await authenticatedRequest(`/api/programas/${programaId}/ordenes-trabajo`);
    }
  };
}
